<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="alertModal"
      hide-header
      hide-footer
      centered
      @hidden="close()"
    >
      <div class="modal-header">
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </div>
      <div class="text-center p-3">
        <font-awesome-icon icon="times-circle" class="icon-error" />
        <p class="text-text" v-if="$store.state.alertError.msg && !$store.state.alertError.isErrorList">{{ $store.state.alertError.msg }}</p>
        <div v-else>
          <p
            v-for="(item, index) in $store.state.alertError.msg"
            :key="index"
            class="text-text f-size-14"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    "$store.state.alertError.isShow": function() {
      if (this.$store.state.alertError.isShow) this.show();
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    close() {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: false, msg : ''});
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  color: #242424;
  margin-bottom: 0;
  font-size: 26px;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.img {
  width: 100px;
}
.f-size-14 {
  font-size: 14px;
}
.icon-error {
  font-size: 130px;
  color: #F55D67;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  /* .text-text {
    font-size: 15px;
  } */
}
</style>